module.exports = __webpack_public_path__ + "static/media/Lexus_t.37b6ff41.jpg";